<template>
  <el-card class="box-card">
    <div class="attachContainer">
      <div class="item">附件列表：</div>
      <div class="item" v-for="item in attachments" :Key="item.Key">
        <viewer v-if="format.estimateIsImage(item.Path)">
        <img v-if="item.Path" :src="baseUrl + item.Path" :key="item.Path" style="height: 30px;width:30px;" />
      </viewer> 
        <span style="font-size: 14px">
          <a :href="baseUrl + item.Path" target="_blank">
            {{ item.Name }}</a>
        </span>
      </div>
    </div>
  </el-card>
</template>
<script>
export default {
  components: {},
  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {};
  },
  watch: {
    attachments: {
      handler (v) {
        if (v.length) {

        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
  },
  mounted () { },
};
</script>
<style lang='scss' scoped>
/deep/.el-card__body,
.el-main {
  padding: 15px;
}
.attachContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  .item {
    margin-right: 30px;
    font-size: 16px;
  }
}
</style>
